import React, { useEffect, useRef, useState, memo } from 'react'
import Highcharts from 'highcharts';
import './M2mGraphChart.css'
import HighchartsReact from 'highcharts-react-official';
const M2mGraphChart = ({key, uniqueId, m2marray, page}:any) => {
    const [data, setData] = useState<any>(m2marray); // Initial data
    const chartRef  = useRef<any>(null)

      useEffect(() => { 
        async function buildM2M (){
          if (page === 'Back') { // This effect runs when the component mounts and whenever m2marray changes 
            setData(m2marray); 
        } 
        }
        buildM2M()
        }, [m2marray, page])

    const options = {
        title: {
            text: ''
        },
        chart:{
            height:50,
            width: null,
            backgroundColor : null
        },
        credits: {
            enabled: false
        },
        tooltip:{
            enabled: false
        },
        xAxis:{
            visible: false
        },
        yAxis: {
            visible: true,
            title:{
              text: ''
            },
            plotLines: [{
              value: 0, // Position the line at 0
              color: 'lightgrey', // Color of the line
              width: 0.5, // Thickness of the line
              zIndex: 4 // Ensures the line is on top of other elements
            }],
            labels: {
              enabled: false // Hide y-axis labels
          }
        },
        legend:{
            enabled : false
        },
        series: [
          {
            type:'area',
            // name: 'Data',
            animation: {
                    duration: 1500, // Duration of the animation in milliseconds
                    easing: 'easeInOutSine' // Easing function for smooth animation
                  },
            data: m2marray,
            lineWidth: 3,
          zones: [
            {
              value: 0, // Values below 0 (negative)
              color: 'orangered' // Negative values in red
            },
            {
              color: 'lightgreen' // Values above 0 (positive)
            }
          ],
            marker: {
                enabled: false,
               states:{
                hover:{
                    enabled : false
                }
               }
             },
             states:{
                hover:{
                    halo : false
                }
               },
               threshold: 0 // Split the line at 0 for positive/negative zones
          }
        ]
      };
    
  return (
    <div className='m2m_parentDiv'>
      {
        m2marray?.length > 0 ? <HighchartsReact highcharts={Highcharts} options={options} /> : <span></span>
      }
    </div>
  )
}

export default memo(M2mGraphChart)




